<template>
  <div class="flex layout-column">
    <div class="layout-row flex">
      <div class="pa-1 mr-1 layout-column lx-panel-content elevation-2"
           style="border-radius: 6px;overflow-y: auto;"
           :style="{'background': compColor.lxExpansion.background}">

        <div class="blue-grey--text layout-column pa-1"
             :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5  text--darken-1' : 'transparent  text--lighten-2']"
             style="border-radius: 5px;"
             :style="{'border': compColor.isInDarkMode ? '1px solid ' + compColor.primeColor + ' !important' : '1px solid transparent'}">

          <v-btn :dark="compColor.isInDarkMode"
                 class="white--text text-none pa-2 mb-2 text-left layout-row layout-align-start-center"
                 :color="compColor.primeColor"
                 dense
                 @click="$emit('click')" depressed :title="$t('buttons.backToOverview.value')">
            <v-icon color="white" left>chevron_left</v-icon>
            <span>{{ $t('buttons.backToOverview.value') }}</span>
          </v-btn>
          <div class="body-2 layout-row layout-align-start-center">
            <span class="caption pl-1 font" :class="compColor.prime + '--text'"
                  style="min-width: 110px;">ID:</span>
            <span class="ml-2"
                  style="min-width:90px;line-height:20px;display: inline-block;">{{ baseData.subjId }}</span>
          </div>
          <div class="body-2 layout-row layout-align-start-center">
            <span class="caption pl-1" :class="compColor.prime + '--text'"
                  style="min-width: 110px;">Diagnose:</span>
            <span class="ml-2"
                  style="min-width:90px;line-height:20px;display: inline-block;">{{ baseData.diagCode }}</span>
          </div>
          <div class="body-2 layout-row layout-align-start-center">
            <span class="caption pl-1" :class="compColor.prime + '--text'"
                  style="min-width: 110px;">vom:</span>
            <span class="ml-2"
                  style="min-width:90px;line-height:20px;display: inline-block;">{{ baseData.diagDate | formatDate('DD.MM.YYYY') }}</span>
          </div>
          <div class="body-2 layout-row layout-align-start-center">
            <span class="caption pl-1" :class="compColor.prime + '--text'"
                  style="min-width: 110px;">Seite:</span>
            <span class="ml-2"
                  style="min-width:90px;line-height:20px;display: inline-block;">{{ getFieldValue(baseData.localization, 'SeitenlokalisationTypesShort') }}</span>
          </div>
        </div>

        <div class="pa-1 layout-column pt-4 sub-headline">
          <div v-for="(navForm, index) in formsNavigationItems"
               :key="index"
               :class="[compColor.prime, navForm.key === formKey ? ' right-triangle white--text' : compColor.prime + '--text text--darken-2 lighten-4']"
               class="mb-2 pa-2 mr-2 doku-nav-btn layout-row"
               @click="formKey=navForm.key"
               v-show="navForm.key==='register' || subjId"
               style="font-weight:500;border-radius:5px;font-size: 13px;line-height: 20px;cursor:pointer;">
            <span class="flex">{{ navForm.navName }}</span>

            <!-- Count of multiple forms -->

            <div class="layout-align-end-center pr-2" v-if="navForm.key !== 'register' && multiFormsCount[navForm.key]">
              <v-avatar color="white" size="20">
                <span class="body-2 font-weight-bold blue-grey--text" style="padding-top: 2px;">{{ multiFormsCount[navForm.key] }}</span>
              </v-avatar>
            </div>
          </div>
        </div>
      </div>

      <div class="flex layout-column">
        <form-details :formKey="formKey"
                      :registerId="registerFormId"
                      :subjId="subjId"
                      :multiFormsCount="multiFormsCount"
                      :tabid="tabid"
                      :deathDate="deathDate"
                      :patientId="patientId"></form-details>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../common/utils'
import formDetails from '../../components/documentation/FormDetails'

export default {
  name: 'Documentation',
  props: ['selectedFormData', 'tabid'],
  components: { formDetails },
  mixins: [utils],
  data () {
    return {
      loading: false,
      formKey: 'register',
      registerFormId: null,
      patientId: null,
      deathDate: null,
      formsNavigationItems: [],
      multipleItems: [],
      count: 0,
      multipleForms: {
        progress: 'Progress',
        operation: 'Operation',
        radiationTherapy: 'Radiation',
        systemicTherapy: 'SystemicTherapy',
        tumorConference: 'TumorConference'
      },
      multiFormsCount: {}
    }
  },
  created () {
    this.patientId = this.selectedFormData.baseData.patientId
    this.deathDate = this.selectedFormData.baseData.deathDate

    this.$eventBus.on('reload-multiForms-count-' + this.patientId, this.getMultiFormsCount, this.$route?.params?.tabid)

    this.formKey = this.selectedFormData.key
    this.registerFormId = this.formKey === 'register' ? this.selectedFormData.form._id : this.selectedFormData.baseData.registerId

    const self = this
    // add forms dynamic to navigation
    this.$store.getters.getformsMetadata.forEach(function (category) {
      self.formsNavigationItems.push(category)
    })
  },
  destroyed () {
    this.$eventBus.remove('reload-multiForms-count-' + this.patientId, this.$route?.params?.tabid)
  },
  methods: {
    /**
     * Get count of multi-forms to show in navigation
     */
    getMultiFormsCount () {
      this.$http.get('/documentation/getMultiFormsCount/' + this.subjId)
        .then(res => {
          if (res.data) {
            this.multiFormsCount = res.data
          }
        })
        .catch(this.NotifyError)
    }
  },
  computed: {
    baseData () {
      return this.$store.getters.diagnosisBaseData(this.patientId)
    },
    subjId () {
      return this.$store.getters.getActualSubjId(this.patientId)
    }
  },
  watch: {
    '$route': {
      handler: function (to) {
        // set formKey and registerFormId manually, when routing from report with selected invalid form
        if ((to?.path === '/patient/details/' + this.tabid + '/' + this.patientId) && this.$store.getters.routingAfterReportValidation(this.patientId)) {
          const storedPatient = this.$store.getters.routingAfterReportValidation(this.patientId)
          this.formKey = storedPatient.formDetails.key
          this.registerFormId = storedPatient.formDetails.registerId
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.doku-nav-btn {
  &:hover {
    filter: brightness(105%);
  }

  &.right-triangle:hover {
    filter: brightness(110%);
  }
}
</style>
